module.exports = __webpack_public_path__ + "assets/img/gzh_ewm.5aa29d54.jpg";